<template>
  <div>
    <SGPRowComponent>
      <div class="p-4">
        <h4> Digite o SOL ID</h4>
        <form @submit.prevent="submit()">
          <SGPFormInputComponent
            name="hdnSolId"
            type="text"         
            placeholder="SOL ID"
            v-model="formulario.hdnSolId"               
          />
          <br>
          <SGPFormBotaoComponent
          type="submit"          
          color="primary"
          block
          rounded
          middle
        >
          <span>Consultar</span>
        </SGPFormBotaoComponent>
        </form>
  
        <!-- Display the retorno -->
        <div class="cla-lista" v-if="temRetorno()">
          <div class="cla-geral">
            <div class="dados">
              <strong>Status</strong><br>
              <pre> {{ retorno.status }}</pre>
            </div>
            <div class="dados flex-column" >
              <strong>Interface EBT</strong><br>
              <pre> {{ retorno.interfaceEBT }}</pre>
            </div>
            <div class="dados" >
              <strong>Interface Cliente</strong><br>
              <pre> {{ retorno.interfaceCliente }}</pre>
            </div>
            <div class="dados" >
              <strong>Local Configuração</strong><br>
              <pre> {{ retorno.localConfiguracao }}</pre>
            </div>
          </div>
          <div class="cla-geral">
            <div class="dados" >
              <strong>vlan</strong><br>
              <pre> {{ retorno.vlan }}</pre>
            </div>
            <div class="dados" >
              <strong>PE</strong><br>
              <pre> {{ retorno.pe }}</pre>
            </div>
            <div class="dados" >
              <strong>Porta</strong><br>
              <pre> {{ retorno.porta }}</pre>
            </div>
            <div class="dados" >
              <strong>SVLAN</strong><br>
              <pre> {{ retorno.sVlan }}</pre>
            </div>
            <div class="dados" >
              <strong>Tipo Porta</strong><br>
              <pre> {{ retorno.tipoPorta }}</pre>
            </div>
          </div>
        </div>
        <div class="cla-lista" v-else-if="submitForm && !temRetorno()">
          <div class="cla-geral">
            <div class="dados">
              <SGPRowComponent>
                <SGPColComponent cols="11">
                  <SGPAlertaComponent class="margin-top-10">
                    Nenhum resultado foi encontrado para sua pesquisa!
                  </SGPAlertaComponent>
                </SGPColComponent>
              </SGPRowComponent>
            </div>
          </div>
        </div>
      </div>

    </SGPRowComponent>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
name: 'ModalConsultaAutomacaoComponent',
components: {
  
},
props:{
  value: {
    type: Boolean,
    required: true,
    default: false
  },
},
data () {
  return {    
      submitForm: false,
      formulario: {
        hdnSolId: ''
      },
      retorno: null
      /*retorno: {
        status: "",
        interfaceEBT: "",
        interfaceCliente: "",
        localConfiguracao: "",
        vlan: "",
        pe: "",
        porta: "",
        sVlan: "",
        tipoPorta: ""
      } */
    }
  },

mounted() {
  if (this.value) {
    this.formulario.hdnSolId = this.value.cla;
  }
},
methods: {
  ...mapActions('automacao', [
    'consultaCLA'
  ]),
  async submit() {
    this.submitForm = true;
    this.retorno = null;
    
    try {
      let response = await this.consultaCLA(this.formulario.hdnSolId);
      if (response.data.message) {
        this.retorno = response.data.message.success;
      } else {
        console.error('Erro ao obter dados:', response);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
    }
  },
  temRetorno(){
    if (this.retorno == null)
      return false;

    if (this.retorno.status == "" || this.retorno.status == null)
      return false;

    return true;
  }
}
}

</script>
<style scoped lang="scss">
.cla-lista {
  padding-top: 15px;
  margin-left: 10px;

  .cla-geral {

    .dados {
      float: left;
      margin-bottom: 10px;
      width: calc(50% - 10px);
    }
  }
}
</style>